/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CombinedGoodsListForPackVo } from './CombinedGoodsListForPackVo';
import {
    CombinedGoodsListForPackVoFromJSON,
    CombinedGoodsListForPackVoFromJSONTyped,
    CombinedGoodsListForPackVoToJSON,
    CombinedGoodsListForPackVoToJSONTyped,
} from './CombinedGoodsListForPackVo';

/**
 * 
 * @export
 * @interface ResponseCombinedGoodsListForPackVo
 */
export interface ResponseCombinedGoodsListForPackVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseCombinedGoodsListForPackVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseCombinedGoodsListForPackVo
     */
    message?: string;
    /**
     * 
     * @type {CombinedGoodsListForPackVo}
     * @memberof ResponseCombinedGoodsListForPackVo
     */
    data?: CombinedGoodsListForPackVo;
}

/**
 * Check if a given object implements the ResponseCombinedGoodsListForPackVo interface.
 */
export function instanceOfResponseCombinedGoodsListForPackVo(value: object): value is ResponseCombinedGoodsListForPackVo {
    return true;
}

export function ResponseCombinedGoodsListForPackVoFromJSON(json: any): ResponseCombinedGoodsListForPackVo {
    return ResponseCombinedGoodsListForPackVoFromJSONTyped(json, false);
}

export function ResponseCombinedGoodsListForPackVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCombinedGoodsListForPackVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : CombinedGoodsListForPackVoFromJSON(json['data']),
    };
}

export function ResponseCombinedGoodsListForPackVoToJSON(json: any): ResponseCombinedGoodsListForPackVo {
    return ResponseCombinedGoodsListForPackVoToJSONTyped(json, false);
}

export function ResponseCombinedGoodsListForPackVoToJSONTyped(value?: ResponseCombinedGoodsListForPackVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': CombinedGoodsListForPackVoToJSON(value['data']),
    };
}

